import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useSessionStorage } from 'usehooks-ts'

import type { TClass } from '@assets/types/globals'
import { useGetInfoAbutMeQuery } from '@store/profile/profile.api'

import type { ClassroomSelectListProps } from './ClassroomSelectList.props'

export function ClassroomSelectList({ ...props }: ClassroomSelectListProps) {
  const { data, isLoading } = useGetInfoAbutMeQuery({})
  const classes = data?.teacher_profile?.managed_classes

  const [classID, setClassID] = useSessionStorage('classID', '')

  const [showList, setShowList] = useState(false)
  const [currentClass, setCurrentClass] = useState<TClass>()

  const handleShowShowList = () => {
    classes && classes?.length > 1 && setShowList((p) => !p)
  }

  const handleChangeClass = (id: string) => {
    const classroom = classes?.find((v) => v?.id === id)

    setCurrentClass(classroom)
    setClassID(classroom?.id!)
    setShowList(false)
  }

  useEffect(() => {
    if (!classID && data) {
      setCurrentClass(classes?.[0])
      setClassID(classes?.[0]?.id!)
    } else {
      setCurrentClass(classes?.find((v) => v?.id === classID))
    }
  }, [data])

  if (isLoading) return null

  return (
    <div className={classNames('header__children select select--children', { 'select--active': showList })}>
      <div
        className="select__top"
        onClick={handleShowShowList}
      >
        <span className="select__value">{`${currentClass?.name}`}</span>

        {classes && classes?.length > 1 && (
          <svg className="select__top-svg">
            <use href="/img/sprite.svg#dropdown-arrow"></use>
          </svg>
        )}
      </div>
      {classes && classes?.length > 1 && (
        <div className="select__bottom">
          <div
            className="select__wrapper"
            style={{ minWidth: 'unset' }}
          >
            <ul className="select__list">
              {classes?.map((v) => (
                <li
                  key={v?.id}
                  className="select__item"
                  onClick={() => handleChangeClass(v?.id)}
                >
                  <span className="select__value">{`${v.name}`}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
